import { render, staticRenderFns } from "./popularize.vue?vue&type=template&id=8400af9e&scoped=true&"
import script from "./popularize.vue?vue&type=script&lang=js&"
export * from "./popularize.vue?vue&type=script&lang=js&"
import style0 from "./popularize.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./popularize.vue?vue&type=style&index=1&id=8400af9e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8400af9e",
  null
  
)

export default component.exports